<template>
  <div class="col-12 p-0 sticky-top pt-2">
    <div class="advertisement">
      <a
        :href="`/cursos/peeling-químico/5/marcio-guidoni/banner`"
        target="_blank"
      >
        <img src="../../assets/img/home/ads_side.jpg" class="w-100" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE
    }
  }
}
</script>

<style>

</style>
